import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "./components/home/home.component";
import { BlogComponent } from "./components/blog/blog.component";
import { PrivacyComponent } from "./components/documents/privacy/privacy.component";
import { TermConditionComponent } from "./components/documents/term-condition/term-condition.component";
import { RefundPolicyComponent } from "./components/documents/refund-policy/refund-policy.component";
import { SocialInitiativeComponent } from "./components/documents/social-initiative/social-initiative.component";
import { GenreComponent } from "./components/genre/genre.component";
import { CareersComponent } from "./components/documents/careers/careers.component";
import { GenredetailComponent } from "./components/genre/genredetail/genredetail.component";
import { BookSessionsFormComponent } from "./components/form/book-sessions-form/book-sessions-form.component";
import { ContactUsComponent } from "./components/form/contact-us/contact-us.component";
import { BlogDeatilsComponent } from "./components/blog/blog-deatils/blog-deatils.component";
import { AuthGuard } from "./services/auth.guard";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
// import { PmShriComponent } from "./components/pm-shri/pm-shri.component";
import { Page404Component } from "./components/page404/page404.component";
import { FlatPanelComponent } from "./components/smartroom/flat-panel/flat-panel.component";
import { AllInOneComponent } from "./components/smartroom/all-in-one/all-in-one.component";
import { HomePannelComponent } from "./components/home-pannel/home-pannel.component";
import { LoginComponent } from "./pages/login/login.component";
import { ProductsPageComponent } from "./components/products/products-page.component";
import { ShutterComponent } from "./components/smartroom/shutter/shutter.component";
import { LmsComponent } from "./components/smartroom/lms/lms.component";
import { K12Component } from "./components/smartroom/k12/k12.component";
import { SolutionsPageComponent } from "./components/solutions/solutions.component";
import { SolutionDetailComponent } from "./components/solutions/solution-detail/solution-detail.component";
import { ResourcesComponent } from "./components/resources/resources.component";
import { CompanyComponent } from "./components/company/company.component";
import { DealerComponent } from "./components/dealer/dealer.component";
import { DigitalELibraryComponent } from "./components/smartroom/digital-e-library/digital-e-library.component";
import { DigitalContentK12Component } from "./components/blog/digital-content-k12/digital-content-k12.component";
import { ChoosingIfpComponent } from "./components/blog/choosing-ifp/choosing-ifp.component";
import { CommonMistakesBuyingIfpComponent } from "./components/blog/common-mistakes-buying-ifp/common-mistakes-buying-ifp.component";
import { ProtectionMattersIfpComponent } from "./components/blog/protection-matters-ifp/protection-matters-ifp.component";
import { BestLmsForSchoolsIndiaComponent } from "./components/blog/best-lms-for-schools-india/best-lms-for-schools-india.component";
import { SmartPanelProtectionGuideIfpShutterComponent } from "./components/blog/smart-panel-protection-guide-ifp-shutter/smart-panel-protection-guide-ifp-shutter.component";
import { AllInOnePcsForComputerLabsAndOfficesComponent } from "./components/blog/all-in-one-pcs-for-computer-labs-and-offices/all-in-one-pcs-for-computer-labs-and-offices.component";
import { K12DigitalContentForSchoolsComponent } from "./components/blog/k12-digital-content-for-schools/k12-digital-content-for-schools.component";
import { ProjectorVsInteractiveFlatPanelComponent } from "./components/blog/projector-vs-interactive-flat-panel/projector-vs-interactive-flat-panel.component";
import { AiPoweredLmsForSchoolsComponent } from "./components/blog/ai-powered-lms-for-schools/ai-powered-lms-for-schools.component";
import { BestInteractiveFlatPanelsVirsaIfpComponent } from "./components/blog/best-interactive-flat-panels-virsa-ifp/best-interactive-flat-panels-virsa-ifp.component";
import { HowVisualLearningImprovesRetentionComponent } from "./components/blog/how-visual-learning-improves-retention/how-visual-learning-improves-retention.component";
import { InteractivePanelsEngagementComponent } from "./components/blog/interactive-panels-engagement/interactive-panels-engagement.component";
import { HiddenCostPanelDamageComponent } from "./components/blog/hidden-cost-panel-damage/hidden-cost-panel-damage.component";
import { OnePlatformSchoolErpLmsSystemVirsaComponent } from "./components/blog/one-platform-school-erp-lms-system-virsa/one-platform-school-erp-lms-system-virsa.component";
import { VirsaAndroid16InteractiveFlatPanelsComponent } from "./components/blog/virsa-android-16-interactive-flat-panels/virsa-android-16-interactive-flat-panels.component";
import { BecomeVirsaChannelPartnerDistributorComponent } from "./components/blog/become-virsa-channel-partner-distributor/become-virsa-channel-partner-distributor.component";
import { FindThePerfectIfpSizeForYourCampusComponent } from "./components/blog/find-the-perfect-ifp-size-for-your-campus/find-the-perfect-ifp-size-for-your-campus.component";
import { RoleOfInteractiveFlatPanelsInRemoteWorkComponent } from "./components/blog/role-of-interactive-flat-panels-in-remote-work/role-of-interactive-flat-panels-in-remote-work.component";
import { HowSmartClassroomSolutionsHelpSchoolsIncreaseAdmissionsComponent } from "./components/blog/how-smart-classroom-solutions-help-schools-increase-admissions/how-smart-classroom-solutions-help-schools-increase-admissions.component";
import { AllInOnePcsForCodingStemSkillDevelopmentLabsComponent } from "./components/blog/all-in-one-pcs-for-coding-stem-skill-development-labs/all-in-one-pcs-for-coding-stem-skill-development-labs.component";
import { BenefitsOfLockableIfpProtectionShuttersComponent } from "./components/blog/benefits-of-lockable-ifp-protection-shutters/benefits-of-lockable-ifp-protection-shutters.component";
import { HowToChooseAnOpsForAnInteractiveFlatPanelComponent } from "./components/blog/how-to-choose-an-ops-for-an-interactive-flat-panel/how-to-choose-an-ops-for-an-interactive-flat-panel.component";
import { NcertAlignedDigitalK12ContentWhatSchoolsShouldKnowComponent } from "./components/blog/ncert-aligned-digital-k12-content-what-schools-should-know/ncert-aligned-digital-k12-content-what-schools-should-know.component";
import { DigitizeAttendanceExamsHomeworkUsingLmsComponent } from "./components/blog/digitize-attendance-exams-homework-using-lms/digitize-attendance-exams-homework-using-lms.component";
import { BeyondTraditionalBlackboardEraOfInteractiveLearningComponent } from "./components/blog/beyond-traditional-blackboard-era-of-interactive-learning/beyond-traditional-blackboard-era-of-interactive-learning.component";
import { BestInteractiveFlatPanelCompanyInIndiaComponent } from "./components/blog/best-interactive-flat-panel-company-in-india/best-interactive-flat-panel-company-in-india.component";
import { BestK12DigitalContentIndiaComponent } from "./components/blog/best-k12-digital-content-india/best-k12-digital-content-india.component";
import { BestLearningManagementSystemIndiaComponent } from "./components/blog/best-learning-management-system-india/best-learning-management-system-india.component";
import { BestIfpProtectionSlidingShutterIndiaComponent } from "./components/blog/best-ifp-protection-sliding-shutter-india/best-ifp-protection-sliding-shutter-india.component";
import { BestAllInOnePcManufacturerIndiaComponent } from "./components/blog/best-all-in-one-pc-manufacturer-india/best-all-in-one-pc-manufacturer-india.component";




const routes: Routes = [
  { path: "", redirectTo: "", pathMatch: "full" },
  {
    path: "interactive-flat-panels",
    redirectTo: "interactive-flat-panel-smart-classroom",
    pathMatch: "full",
  },
  {
    path: "smart-classroom-solutions",
    redirectTo: "solutions",
    pathMatch: "full",
  },
  {
    path: "ifp-sliding-shutters",
    redirectTo: "shutter-system",
    pathMatch: "full",
  },
  {
    path: "ifp-protection-shutter",
    redirectTo: "shutter-system",
    pathMatch: "full",
  },
  {
    path: "all-in-one-pc",
    redirectTo: "all-in-one-pc-computers-accessories",
    pathMatch: "full",
  },
  {
    path: "contact-us",
    redirectTo: "form/contactUs",
    pathMatch: "full",
  },
  {
    path: "form/contact-us",
    redirectTo: "form/contactUs",
    pathMatch: "full",
  },
  {
    path: "smart-meeting-room-solutions",
    redirectTo: "solutions/corporates",
    pathMatch: "full",
  },
  {
    path: "wireless-screen-sharing",
    redirectTo: "interactive-flat-panel-smart-classroom",
    pathMatch: "full",
  },
  {
    path: "ops-modules",
    redirectTo: "all-in-one-pc-computers-accessories",
    pathMatch: "full",
  },
  {
    path: "ops",
    redirectTo: "all-in-one-pc-computers-accessories",
    pathMatch: "full",
  },
  {
    path: "k12-content",
    redirectTo: "k-12-digital-content",
    pathMatch: "full",
  },
  {
    path: "ai-lms",
    redirectTo: "lms",
    pathMatch: "full",
  },
  {
    path: "ai-powered-lms",
    redirectTo: "lms",
    pathMatch: "full",
  },
  {
    path: "all-in-one-pcs",
    redirectTo: "all-in-one-pc-computers-accessories",
    pathMatch: "full",
  },
  {
    path: "",
    component: HomePannelComponent,
    title: "Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },
  {
    path: "culture-app",
    component: HomeComponent,
    title: "Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },
  // {
  //   path: "genre",
  //   component: GenreComponent,
  //   title: "Genre | Virsa the Digital Learning | Virsa",
  // },
  // { path: "genre/genre-details/:id", component: GenredetailComponent },
  // { path: "genre/genre-details", redirectTo: "genre", pathMatch: "full" },

  {
    path: "interactive-flat-panel-smart-classroom",
    component: FlatPanelComponent,
    title: "Premium Interactive Flat Panel 65,75 & 86 Inch | Smart Classroom",
  },
  {
    path: "shutter-system",
    component: ShutterComponent,
    title: "Shutter System | Safety + Durability | Virsa",
  },
  {
    path: "lms",
    component: LmsComponent,
    title: "LMS Platform | Complete Learning Management Ecosystem | Virsa",
  },
  {
    path: "k-12-digital-content",
    component: K12Component,
    title: "K-12 Digital Content | NCERT-Aligned Animated Content | Virsa",
  },
  {
    path: "digital-e-library",
    component: DigitalELibraryComponent,
    title: "Digital E-Library | Interactive Books & Activities | Virsa",
  },
  {
    path: "all-in-one-pc-computers-accessories",
    component: AllInOneComponent,
    title: "Buy All In One PC Intel Core i5 | Computers & Accessories",
  },
  // {
  //   path: "pm-shri",
  //   component: PmShriComponent,
  //   title: "PM Shri Schools | PM Shri Schools Activity | Virsa",
  // },
  {
    path: "blog",
    component: BlogComponent,
    title: "Blog | Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },
  {
    path: "blog/digital-content-k12",
    component: DigitalContentK12Component,
    title: "Digital Content for K-12 Schools | Smart Classroom Solutions by Virsa",
  },
  {
    path: "blog/choosing-the-right-interactive-flat-panel-for-your-school",
    component: ChoosingIfpComponent,
    title: "Choosing the Right Interactive Flat Panel for Your School | IFP Buying Guide India",
  },
  {
    path: "blog/common-mistakes-schools-make-while-buying-interactive-flat-panels-ifp",
    component: CommonMistakesBuyingIfpComponent,
    title: "Best Interactive Flat Panel for Schools | Buying Guide - Virsa",
  },
  {
    path: "blog/why-protection-matters-extending-the-life-of-your-interactive-flat-panels",
    component: ProtectionMattersIfpComponent,
    title: "Why Protection Matters for Interactive Flat Panels | Virsa",
  },
  {
    path: "blog/best-lms-for-schools-in-india-unified-learning-management-system",
    component: BestLmsForSchoolsIndiaComponent,
    title: "Best LMS for Schools in India | Unified Learning Management System",
  },
  {
    path: "blog/smart-panel-protection-guide-ifp-shutter",
    component: SmartPanelProtectionGuideIfpShutterComponent,
    title: "Complete Protection Guide: Dust, Impact, and Safety for Smart Panels | Virsa IFP Protection",
  },
  {
    path: "blog/all-in-one-pcs-for-computer-labs-and-offices",
    component: AllInOnePcsForComputerLabsAndOfficesComponent,
    title: "Why All-in-One PCs Are Ideal for Computer Labs and Offices | Virsa",
  },
  {
    path: "blog/k12-digital-content-for-schools",
    component: K12DigitalContentForSchoolsComponent,
    title: "K-12 Digital Content for Schools | Interactive Learning Solutions by Virsa",
  },
  {
    path: "blog/projector-vs-interactive-flat-panel",
    component: ProjectorVsInteractiveFlatPanelComponent,
    title: "Projector vs Interactive Flat Panel: What Schools Should Choose in 2026 | Virsa",
  },
  {
    path: "blog/ai-powered-lms-for-schools",
    component: AiPoweredLmsForSchoolsComponent,
    title: "AI-Powered LMS for Schools | Next-Gen Personalized Learning by Virsa",
  },
  {
    path: "blog/best-interactive-flat-panels-virsa-ifp",
    component: BestInteractiveFlatPanelsVirsaIfpComponent,
    title: "Best Interactive Flat Panels for Schools, Colleges & Offices | Virsa Interactive Flat Panels",
  },
  {
    path: "blog/how-visual-learning-improves-retention-and-exam-performance",
    component: HowVisualLearningImprovesRetentionComponent,
    title: "How Visual Learning Improves Retention & Exam Performance | Virsa",
  },
  {
    path: "blog/interactive-panels-improve-student-engagement-learning-outcomes",
    component: InteractivePanelsEngagementComponent,
    title: "How Interactive Panels Improve Student Engagement & Learning Outcomes | Virsa",
  },
  {
    path: "blog/hidden-cost-of-panel-damage-schools",
    component: HiddenCostPanelDamageComponent,
    title: "The Hidden Cost of Panel Damage in Schools & How to Avoid It | Virsa",
  },
  {
    path: "blog/one-platform-school-erp-lms-system-virsa",
    component: OnePlatformSchoolErpLmsSystemVirsaComponent,
    title: "One Platform for Students, Teachers & Parents | Virsa LMS System",
  },
  {
    path: "blog/virsa-android-16-interactive-flat-panels",
    component: VirsaAndroid16InteractiveFlatPanelsComponent,
    title: "VIRSA Android 16 Interactive Flat Panels for Smart Classrooms",
  },
  {
    path: "blog/become-virsa-channel-partner-distributor",
    component: BecomeVirsaChannelPartnerDistributorComponent,
    title: "Become a VIRSA Channel Partner, Dealer & Distributor in India",
  },
  {
    path: "blog/find-the-perfect-ifp-size-for-your-campus",
    component: FindThePerfectIfpSizeForYourCampusComponent,
    title: "Find the Perfect IFP Size for Your Campus | VIRSA Interactive Flat Panels",
  },
  {
    path: "blog/role-of-interactive-flat-panels-in-remote-work",
    component: RoleOfInteractiveFlatPanelsInRemoteWorkComponent,
    title: "The Role of Interactive Flat Panels in Remote Work & Hybrid Collaboration | VIRSA",
  },
  {
    path: "blog/how-smart-classroom-solutions-help-schools-increase-admissions",
    component: HowSmartClassroomSolutionsHelpSchoolsIncreaseAdmissionsComponent,
    title: "How Virsa Smart Classroom Solutions Help Schools Increase Admissions in 2026 | VIRSA",
  },
  {
    path: "blog/all-in-one-pcs-for-coding-stem-skill-development-labs",
    component: AllInOnePcsForCodingStemSkillDevelopmentLabsComponent,
    title: "Best All-in-One PCs for Coding, STEM & Skill Development Labs VIRSA",
  },
  {
    path: "blog/benefits-of-lockable-ifp-protection-shutters",
    component: BenefitsOfLockableIfpProtectionShuttersComponent,
    title: "Benefits of Lockable IFP Protection Shutters for Schools | VIRSA IFP Safety Solutions",
  },
  {
    path: "blog/how-to-choose-an-ops-for-an-interactive-flat-panel",
    component: HowToChooseAnOpsForAnInteractiveFlatPanelComponent,
    title: "How to Choose an OPS for an Interactive Flat Panel | VIRSA",
  },
  {
    path: "blog/ncert-aligned-digital-k12-content-what-schools-should-know",
    component: NcertAlignedDigitalK12ContentWhatSchoolsShouldKnowComponent,
    title: "NCERT-Aligned Digital K–12 Content for Schools | VIRSA",
  },
  {
    path: "blog/digitize-attendance-exams-homework-using-lms",
    component: DigitizeAttendanceExamsHomeworkUsingLmsComponent,
    title: "Digitize Attendance, Exams & Homework with LMS | VIRSA",
  },
  {
    path: "blog/beyond-traditional-blackboard-era-of-interactive-learning",
    component: BeyondTraditionalBlackboardEraOfInteractiveLearningComponent,
    title: "Beyond the Traditional Blackboard: The Era of Interactive Learning | VIRSA",
  },
  {
    path: "blog/best-interactive-flat-panel-company-in-india",
    component: BestInteractiveFlatPanelCompanyInIndiaComponent,
    title: "Best Interactive Flat Panel Company in India | VIRSA",
  },
  {
    path: "blog/best-k12-digital-content-india",
    component: BestK12DigitalContentIndiaComponent,
    title: "Best K–12 Digital Content in India | VIRSA",
  },
  {
    path: "blog/best-learning-management-system-india",
    component: BestLearningManagementSystemIndiaComponent,
    title: "Best LMS in India | Learning Management System | VIRSA",
  },
  {
    path: "best-learning-management-system-india",
    redirectTo: "blog/best-learning-management-system-india",
    pathMatch: "full",
  },
  {
    path: "blog/best-ifp-protection-sliding-shutter-india",
    component: BestIfpProtectionSlidingShutterIndiaComponent,
    title: "Best IFP Protection Sliding Shutter Provider in India | VIRSA",
  },
  {
    path: "best-ifp-protection-sliding-shutter-india",
    redirectTo: "blog/best-ifp-protection-sliding-shutter-india",
    pathMatch: "full",
  },
  {
    path: "blog/best-all-in-one-pc-manufacturer-india",
    component: BestAllInOnePcManufacturerIndiaComponent,
    title: "Best All-in-One PC Manufacturer in India | VIRSA",
  },
  {
    path: "best-all-in-one-pc-manufacturer-india",
    redirectTo: "blog/best-all-in-one-pc-manufacturer-india",
    pathMatch: "full",
  },


  { path: "blog/:slug", component: BlogDeatilsComponent },
  {
    path: "form/book-sessions-form",
    component: BookSessionsFormComponent,
    title: "Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },
  {
    path: "form/:name",
    component: ContactUsComponent,
    title: "Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },
  {
    path: "privacy",
    component: PrivacyComponent,
    title: "Privacy | Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },
  {
    path: "term-condition",
    component: TermConditionComponent,
    title: "Term Condition | Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },
  {
    path: "refund-policy",
    component: RefundPolicyComponent,
    title: "Refund Policy | Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },
  {
    path: "social-initiative",
    component: SocialInitiativeComponent,
    title: "Social Initiative  | Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },

  {
    path: "careers",
    component: CareersComponent,
    title: "Careers | Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },
  {
    path: "products",
    component: ProductsPageComponent,
    title: "Products | Virsa - Digital Learning & Smart Classroom Solutions Company in India",
  },
  {
    path: "solutions",
    component: SolutionsPageComponent,
    title: "Smart Solutions for Every Learning Environment | Virsa",
  },
  {
    path: "solutions/:type",
    component: SolutionDetailComponent,
    title: "Solution Details | Virsa",
  },
  {
    path: "resources",
    component: ResourcesComponent,
    title: "Resources | Virsa",
  },
  {
    path: "about-us",
    component: CompanyComponent,
    title: "About Virsa | Leadership, Vision & Careers",
  },
  {
    path: "partner",
    component: DealerComponent,
    title: "Become a Partner | Partner with Virsa",
  },
  {
    path: "profile",
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    loadChildren: () =>
      import("./modules/myVirsa/my-virsa.module").then((m) => m.MyVirsaModule),
  },
  {
    path: "international-class",
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    loadChildren: () =>
      import("./modules/international/international.module").then(
        (m) => m.InternationalModule
      ),
  },
  { path: "login", component: LoginComponent },
  { path: "404", component: Page404Component },
  { path: "**", redirectTo: "404" },
];

@NgModule({
  imports: [BrowserModule, FormsModule, RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64] // Optional: adjusts for header height if sticky
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
